import reportAnalyticCount from 'ui-forms-embed-components-reporting/reporting/reportAnalyticCount';
const reportErrorToGrafana = ({
  key,
  isQa,
  hublet
}) => {
  const projectName = 'developer-forms-embed';
  const renderVersion = 'v3-developer';
  reportAnalyticCount(`${projectName}-${renderVersion}-${key}`, 1, {
    env: isQa ? 'qa' : 'prod',
    hublet
  });
};
export default reportErrorToGrafana;